import { render, staticRenderFns } from "./FollowObservations.vue?vue&type=template&id=e2dd24fe&"
import script from "./FollowObservations.vue?vue&type=script&lang=js&"
export * from "./FollowObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports